// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @internal
 */
export const packageVersion = "1.9.0";

/**
 * @internal
 */
export const appConfigurationApiVersion = "2023-11-01";
